// A device key for a machine without the Mac app (Linux, CI): shown once, with the command that uses it.
import { useState } from 'react';
import { Banner, Field, Select, Sheet, TextInput, onValue } from '../components/common.tsx';
import { useStore } from '../store/hooks.tsx';
import { Button } from '../ui/ds.tsx';

export function AddDeviceSheet() {
  const store = useStore();
  const t = store.t;
  const [name, setName] = useState('');
  const [platform, setPlatform] = useState('linux');
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const [working, setWorking] = useState(false);
  const close = () => store.closeSheet();
  const server = window.location.origin;
  const command = token ? `tally login --server ${server} --device-token ${token}` : '';
  const create = async () => {
    setWorking(true);
    try {
      const created = await store.api.addDevice(name.trim() || t('Rechner'), platform);
      setToken(created.token);
      await store.refreshMe();
    } catch (e) {
      setError(store.describe(e));
    } finally {
      setWorking(false);
    }
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
    } catch { /* the text is selectable */ }
  };
  return (
    <Sheet title={t('Gerät hinzufügen')} subtitle={t('Für Rechner ohne Mac-App, z. B. Linux oder CI. Die CLI meldet Events direkt an diesen Server, der sie zählt.')}
      onClose={close} footer={<>
        <span className="spacer" />
        {token ? <Button variant="primary" onClick={close}>{t('Fertig')}</Button> : (
          <>
            <Button variant="plain" onClick={close}>{t('Abbrechen')}</Button>
            <Button variant="primary" disabled={working} onClick={() => void create()}>{t('Schlüssel erzeugen')}</Button>
          </>
        )}
      </>}>
      {error ? <Banner tone="danger">{error}</Banner> : null}
      {!token ? (
        <form className="form" onSubmit={(e) => { e.preventDefault(); void create(); }}>
          <Field label={t('Name')}><TextInput autoFocus value={name} placeholder={t('z. B. Build-Server')} onChange={onValue(setName)} /></Field>
          <Field label={t('System')}>
            <Select value={platform} onChange={(e) => setPlatform(e.target.value)}>
              <option value="linux">Linux</option>
              <option value="ci">CI</option>
              <option value="other">{t('Anderes')}</option>
            </Select>
          </Field>
          <button type="submit" hidden />
        </form>
      ) : (
        <>
          <Banner tone="waiting" icon="alert">{t('Der Schlüssel wird nur jetzt angezeigt. Er darf nur Events melden und abgleichen; du kannst ihn jederzeit entfernen.')}</Banner>
          <div className="stack">
            <span className="field__label">{t('1. Auf dem Rechner anmelden')}</span>
            <pre className="code-block">{command}</pre>
            <div><Button size="sm" icon="copy" onClick={() => void copy()}>{copied ? t('Kopiert') : t('Befehl kopieren')}</Button></div>
          </div>
          <div className="stack">
            <span className="field__label">{t('2. Agents verbinden')}</span>
            <pre className="code-block">{'tally connect claude-code --yes\ntally connect codex --yes'}</pre>
            <p className="note">{t('Die Hooks puffern offline und senden im Hintergrund. Sessions erscheinen hier, sobald ein Agent arbeitet.')}</p>
          </div>
        </>
      )}
    </Sheet>
  );
}
